import { post } from 'axios';

const { VUE_POWER_BI_REFRESH_URL: refreshUrl = '' } = process.env || {};

export const refreshData = () => (refreshUrl ? post(refreshUrl) : false);
